/**
 * @generated SignedSource<<99804e32e8201ea2d886cb460e5b6384>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentHeaderPresence_contentSetting$data = {
  readonly isEnabledOnContentView: boolean;
  readonly " $fragmentType": "ContentHeaderPresence_contentSetting";
};
export type ContentHeaderPresence_contentSetting$key = {
  readonly " $data"?: ContentHeaderPresence_contentSetting$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentHeaderPresence_contentSetting">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ContentHeaderPresence_contentSetting",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEnabledOnContentView"
    }
  ],
  "type": "ConfluenceTeamPresence"
};

(node as any).hash = "303742832bfb08703ddffbad402ced83";

export default node;
